import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import queryString from 'query-string';
import { Service } from './service';
import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { Card, Typography, Row, Col, Space, Form, Button } from 'antd';
import { default as checkIcon } from '../../../../../../_config/images/check-magistal.png';
import './style.scss';
import { ModalTypeRecipes } from '../../../../../../components/Commons/Modals/ModalTypeRecipes';

import { default as magistralIcon } from '../../../../../../_config/images/formulamagistral.png';
import { default as pharmacy_icon } from '../../../../../../_config/global/logo.jpg';

import { GetLocalStorageValue } from '../../../../../../_config/adapters/local-storage/get-local-storage-value.adapter';
import LoadingPage from '../../../../../../v2-components/LoadingPage';
import CustomLink from '../../../../../../v2-components/Antd/Link';
import HandleAddProductElectronic from '../../../../../../pages/carts/functions/BagAddProductElectronic';
import CustomMediaViewer from '../../../../../../v2-components/CustomMediaViewer';
import { ProductosMagistralItem } from './components/ProductsMagistralItem';
import { ProductosMagistralRejectedItem } from './components/ProductsMagistralRejectedItem';
import CustomCard from '../../../../../../v2-components/Antd/Card';
import { UnixToDate } from '../../handle/unix-to-date.handle';

const { Text } = Typography;

const ProfileMagistralDetailPage = () => {
	const { id, operation_id, page } = useParams();
	const history = useHistory();
	const email = GetLocalStorageValue('userEmail');
	const [magistralQuotation, setMagistralQuotation] = useState();
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [productsMagistral, setProductsMagistral] = useState(null);
	const [productsMagistralRejected, setProductsMagistralRejected] = useState(null);
	const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
	const [selectAllChecked, setSelectAllChecked] = useState(false);
	const { handleAddProductCartElectronic } = HandleAddProductElectronic();
	const [cartForm] = Form.useForm();
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [requestNumber, setRequestNumber] = useState(null); // short_code
	const user = JSON.parse(localStorage.getItem('userMainInfo'));
	const token = user?.token || null;
	const [loadingRequote, setLoadingRequote] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		// const params = queryString.parse(location.search);
		const payload = {
			page: page,
			country: Enviroment.COUNTRY,
			pharmacy: Enviroment.ROOT_PHARMACY,
			user_email: email,
		};

		(async () => {
			try {
				const service = new Service();

				const response = await service.getMagistralQuotation(payload);
				const list = response.data;
				setMagistralQuotation(list);

				const found = list.find((item) => item.short_code === operation_id);
				if (!found) {
					console.warn('No se encontró la cotización con ese operation_id');
					return;
				}
				const productsRejected = await service.getMagistralByID(id);

				// Modificando los productos rechazados antes de setear
				productsRejected.magistral_products.forEach((product, i) => {
					product.price = product.final_unit_price;
				});

				productsRejected.magistral_products_prepare.forEach((product, i) => {
					product.price = product.final_unit_price;
				});

				setProductsMagistralRejected(productsRejected);

				const products = await service.getBagOnDemand(found.validation_token);
				// Modificando los productos antes de setear
				products.products.forEach((product, i) => {
					product.price = product.final_unit_price;
				});
				setProductsMagistral(products);

			} catch (err) {
				console.error(err);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [location.search, email, operation_id, id, page]);

	if (isLoading) {
		return <LoadingPage />;
	}

	const selectedQuotation = magistralQuotation.find((item) => item.short_code === operation_id);

	const rejectedProducts = productsMagistralRejected
		? [
				...(productsMagistralRejected.magistral_products || []).map((p) => ({
					...p,
					__type: 'magistral',
				})),
				...(productsMagistralRejected.commercial_products || []).map((p) => ({
					...p,
					__type: 'commercial',
				})),
				...(productsMagistralRejected.magistral_products_prepare || []).map((p) => ({
					...p,
					__type: 'magistral_prepare',
				})),
		  ]
		: [];

	console.log('lalal', rejectedProducts, productsMagistralRejected, productsMagistral);

	const handleRequote = async () => {
		setLoadingRequote(true);

		let magistralProductIds = [];
		let commercialProductIds = [];

		if (productsMagistral && productsMagistral?.statusCode !== 500) {
			const selectedProducts = productsMagistral.products.filter((_, index) => selectedCheckboxes.includes(index));

			magistralProductIds = selectedProducts
				.filter((item) => item.product_type === 'MAGISTRAL_READY' || item.product_type === 'MAGISTRAL_TO_PREPARE')
				.map((item) => item.id);

			commercialProductIds = selectedProducts
				.filter((item) => item.product_type === 'COMERCIAL' || !(item.product_type === 'MAGISTRAL_READY' || item.product_type === 'MAGISTRAL_TO_PREPARE'))
				.map((item) => item.id);
		} else {
			const selectedRejected = rejectedProducts.filter((_, index) => selectedCheckboxes.includes(index));

			magistralProductIds = selectedRejected.filter((item) => item.__type === 'magistral' || item.__type === 'magistral_prepare').map((item) => item.id);
			commercialProductIds = selectedRejected.filter((item) => item.__type === 'commercial').map((item) => item.id);
		}

		const payload = {
			quotation_id: id,
			magistral_product_ids: magistralProductIds,
			commercial_product_ids: commercialProductIds,
		};

		console.log('payload requote', payload);

		try {
			const response = await new Service().requoteMagistral(payload, token);
			if (response?.short_code) {
				setRequestNumber(response.short_code);
				setShowConfirmation(true);
			} else {
				console.error('Error al volver a cotizar');
			}
		} catch (error) {
			console.error('Ocurrió un error al intentar volver a cotizar');
		} finally {
			setLoadingRequote(false);
		}
	};

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const handleTypeRecipes = () => {
		setIsModalOpen(true);
	};

	const handleCheckboxChange = (index) => {
		setSelectedCheckboxes((prev) => {
			let next;

			if (prev.includes(index)) {
				next = prev.filter((item) => item !== index);
			} else {
				next = [...prev, index];
			}

			const totalItems = productsMagistral && productsMagistral?.statusCode !== 500 ? productsMagistral?.products?.length || 0 : rejectedProducts.length;

			setSelectAllChecked(next.length === totalItems && totalItems > 0);

			return next;
		});
	};

	const handleSelectAllChange = () => {
		setSelectAllChecked((prev) => {
			const newValue = !prev;
			if (newValue && productsMagistral?.products) {
				setSelectedCheckboxes(productsMagistral.products.map((_, index) => index));
			} else {
				setSelectedCheckboxes([]);
			}
			return newValue;
		});
	};

	const handleSelectAllRejected = () => {
		setSelectAllChecked((prev) => {
			const newValue = !prev;
			if (newValue) {
				setSelectedCheckboxes(rejectedProducts.map((_, index) => index));
			} else {
				setSelectedCheckboxes([]);
			}
			return newValue;
		});
	};

	const handleBackToPharmacy = () => {
		history.push('/');
	};

	const handleVolver = () => {
		history.push('/profile-info/magistral-formula');
	};

	if (loadingRequote) {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth', // o 'auto' si no quieres animación
		});
		return <LoadingPage />;
	}

	if (showConfirmation) {
		return (
			<div className="quote-request-container">
				<div className="header-section">
					<h2 style={{ marginBottom: '0' }}>Solicitud de cotización</h2>
					<Button type="link" onClick={handleBackToPharmacy} className="back-link">
						Volver a farmacia
					</Button>
				</div>
				<div className="confirmation-wrapper">
					<div className="confirmation-card">
						<div className="confirmation-content">
							<div>
								<img src={checkIcon} alt="Check" width={180} height={180} />
							</div>
							<div className="confirmation-text">
								<p className="confirmation-title">
									¡Gracias por tu solicitud <span className="request-number">{requestNumber}</span>!
								</p>
								<p className="contact-info">Te estaremos enviando un mail cuando la farmacia haya cotizado tu receta</p>
								<Button type="primary" size="large" onClick={handleVolver} className="volver-btn">
									Seguir navegando
								</Button>
								<Text className="contact-info">
									Revisa tu correo electrónico, verifica tus productos y número de solicitud. De no recibir el correo con tu solicitud, escríbenos a{' '}
									<a href="mailto:contacto@narma.cl" className="contact-email">
										contacto@narma.cl
									</a>
								</Text>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="profile-magistral-detail">
			<div className="header-section">
				<Space direction="vertical" size="small">
					<h2 className="solicitud-title">Solicitud {selectedQuotation?.short_code}</h2>
					<CustomLink style={{ fontWeight: '600' }} className={'back-link'} to="/profile-info/magistral-formula">
						Volver a mis solicitudes
					</CustomLink>
				</Space>
			</div>

			<Row gutter={24}>
				<Col xs={24} lg={11}>
					<Card className="solicitud-card">
						<div className="solicitud-header">
							<h3>Solicitud N° {selectedQuotation?.short_code}</h3>
							<Text className="solicitud-date">{UnixToDate(selectedQuotation?.created_at)}</Text>
						</div>

						<Space direction="vertical" size="middle" className="solicitud-info">
							<div>
								<Text> Tipo de solicitud: </Text>
								<Text> Recetario magistral </Text>
							</div>
							<div>
								<Text>Farmacia: {selectedQuotation?.pharmacy}</Text>
							</div>
							<div>
								<Text>Estado: {selectedQuotation?.status_tracking.status_description}</Text>
							</div>
						</Space>

						<div className="solicitante-section" style={{ marginTop: '20px' }}>
							<h3>Solicitante</h3>
							<Space direction="vertical" size="small">
								<div>
									<Text>Nombre y apellido: {selectedQuotation?.user_info.first_name + ' ' + selectedQuotation?.user_info.last_name}</Text>
								</div>
								<div>
									<Text>RUT: {selectedQuotation?.user_info.rut}</Text>
								</div>
								<div>
									<Text>Correo electrónico: {selectedQuotation?.user_info.email}</Text>
								</div>
								<div>
									<Text>Teléfono: {selectedQuotation?.user_info.phone}</Text>
								</div>
							</Space>
						</div>

						<div className="receta-section">
							<h3 style={{ marginTop: '20px' }}>Receta enviada</h3>
							{selectedQuotation?.recipe.map((item, index) => (
								<div
									key={index}
									className="receta-image-container"
									style={{
										marginBottom: '30px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'flex-start',
									}}
								>
									<CustomMediaViewer src={item.url} />
									<div style={{ marginTop: '8px' }}>Vto de la receta: {item.expiration_date}</div>
								</div>
							))}
						</div>
					</Card>
				</Col>

				<Col xs={24} lg={13}>
					{productsMagistral && productsMagistral?.statusCode !== 500 ? (
						<CustomCard className="productos-card">
							<h3>Productos</h3>
							<hr />

							{productsMagistral.products.map((item, index) => (
								<Row key={index} gutter={[16, 16]} align="top" className="producto-row">
									<Col span={23}>
										<ProductosMagistralItem
											item={item}
											index={index}
											handleTypeRecipes={handleTypeRecipes}
											magistralIcon={magistralIcon}
											pharmacy_icon={pharmacy_icon}
											cartForm={cartForm}
											status_tracking={productsMagistralRejected.status_tracking}
											selectedCheckboxes={selectedCheckboxes}
											handleCheckboxChange={handleCheckboxChange}
										/>
									</Col>
								</Row>
							))}
							{productsMagistralRejected.status_tracking.status !== 100 && (
								<>
									<div>
										<input
											type="checkbox"
											checked={selectAllChecked}
											onChange={handleSelectAllChange}
											style={{ height: '16px', width: '16px', accentColor: '#00263a' }}
										/>
										<label style={{ marginLeft: '10px' }}>Seleccionar todos los productos</label>
									</div>

									<div className="volver-cotizar-container">
										<Button
											type="primary"
											disabled={selectedCheckboxes.length === 0 || loadingRequote}
											loading={loadingRequote}
											className="volver-cotizar-btn"
											onClick={handleRequote}
										>
											Volver a cotizar
										</Button>
									</div>
								</>
							)}
						</CustomCard>
					) : (
						rejectedProducts.length > 0 && (
							<CustomCard className="productos-card">
								<h3>Productos</h3>
								<hr />

								{rejectedProducts.map((item, index) => (
									<Row key={index} gutter={[16, 16]} align="top" className="producto-row">
										<Col span={23}>
											<ProductosMagistralRejectedItem
												item={item}
												index={index}
												type={item.__type}
												handleTypeRecipes={handleTypeRecipes}
												magistralIcon={magistralIcon}
												pharmacy_icon={pharmacy_icon}
												handleAddProductCartElectronic={handleAddProductCartElectronic}
												cartForm={cartForm}
												status_tracking={productsMagistralRejected.status_tracking}
												selectedCheckboxes={selectedCheckboxes}
												handleCheckboxChange={handleCheckboxChange}
											/>
										</Col>
									</Row>
								))}

								{productsMagistralRejected.status_tracking.status !== 100 && (
									<>
										<div>
											<input
												style={{ height: '16px', width: '16px', accentColor: '#00263a' }}
												type="checkbox"
												checked={selectAllChecked}
												onChange={handleSelectAllRejected}
											/>
											<label style={{ marginLeft: '10px' }}>Seleccionar todos los productos</label>
										</div>
										<div className="volver-cotizar-container">
											<Button
												type="primary"
												disabled={selectedCheckboxes.length === 0 || loadingRequote}
												loading={loadingRequote}
												className="volver-cotizar-btn"
												onClick={handleRequote}
											>
												Volver a cotizar
											</Button>
										</div>
									</>
								)}
							</CustomCard>
						)
					)}
				</Col>
			</Row>

			<ModalTypeRecipes isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel} />
		</div>
	);
};

export default ProfileMagistralDetailPage;
